webpackJsonp([10],{

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Topic: function Topic() {
      return __webpack_require__.e/* import() */(21/* duplicate */).then(__webpack_require__.bind(null, 96));
    }
  },
  data: function data() {
    return {
      tags: ['React', 'React Native', 'Mobile App', 'Exploration']
    };
  }
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('topic',{attrs:{"title":"Transferring Painlessly from Web to Mobile Apps with React Native","speaker":"Rachel","icon":"/2017/img/speaker/rachel.jpg","venue":"LT 17","time":"12:15 - 13:00","tags":_vm.tags,"language":"English","live":"https://www.youtube.com/watch?v=/8favjxhj7vs"}},[_c('p',{attrs:{"slot":"speaker"},slot:"speaker"},[_vm._v("\n    A Taiwanese Computer Engineering student studying at HKU.\n    Every piece of knowledge is at a beta stage.\n    Wishing to advance from knowing nothing to knowing something.\n  ")]),_vm._v(" "),_c('p',{attrs:{"slot":"abstract"},slot:"abstract"},[_vm._v("\n    Mobile app development used to be a totally different story from web development — developers code in different languages,\n    target on different hardware resources, and deal with different performance issues.\n    Fortunately, solutions have been provided by some tech giants to fill up part of the gap\n    and to make mobile app development much more approachable to web developers.\n    React Native is one of the most popular solutions,\n    by which you can build mobile apps with zero knowledge of Java and Swift/Objective-C\n    without sacrificing the performance.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReactNative_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45258f88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ReactNative_vue__ = __webpack_require__(348);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReactNative_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45258f88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ReactNative_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// 10.50b0024b82c7fd222b57.js